// 🧪 베타 채널 판정 (2026-09-27, docs/RELEASE.md §1-B) — 운영 번들·운영 index 에는 두 신호가 모두 없어 항상 null.
//   웹 베타: beta.js 가 ~/tptalk-web/_beta/index.html 에만 <meta name="tpt-channel" content="beta:<sha>"> 를 넣는다
//            (같은 번들이라도 운영 index 로 열리면 meta 가 없다 → 운영과 구분).
//   데스크톱 베타: beta_desktop.js 가 빌드 env VITE_TPT_CHANNEL=beta · VITE_TPT_BETA_REF=<sha> 를 박는다.
function readBetaRef(): string | null {
	const env = (import.meta as { env?: Record<string, string> }).env;
	if (env?.VITE_TPT_CHANNEL === 'beta') return env.VITE_TPT_BETA_REF || 'desktop';
	try {
		const c = document.querySelector('meta[name="tpt-channel"]')?.getAttribute('content') || '';
		if (c.startsWith('beta')) return c.slice(5) || 'web';
	} catch { /* SSR·테스트 환경 */ }
	return null;
}

/** 베타 빌드 식별자(커밋 sha 등). 운영이면 null. */
export const BETA_REF: string | null = readBetaRef();
export const IS_BETA = BETA_REF !== null;
/** 데스크톱 베타 앱(TPTalk Beta) 전용 빌드 — 정식 앱과 공유하는 OS 자원(Windows Hello 키 등)을 건드리면 안 된다. */
export const IS_DESKTOP_BETA = (import.meta as { env?: Record<string, string> }).env?.VITE_TPT_CHANNEL === 'beta';
